import { useEffect } from "react";
import { SITE, url } from "../data/site";

export const Seo = ({ title, description, path, type = "website", jsonLd = [], noindex = false }) => {
  const canonical = url(path);
  const ldString = JSON.stringify(jsonLd);

  useEffect(() => {
    const scripts = jsonLd.map((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ldString]);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex" : "index,follow,max-image-preview:large"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.brand} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="theme-color" content="#0F172A" />
    </>
  );
};
